import React from "react";
import styles from "./PageContainer.module.css";
import { Outlet, useLocation } from "react-router-dom";
import { NavigationSidebar } from "./navigation/Navigation";
import { TopBar, TopBarProps } from "./TopBar";
import { EnvironmentBanner } from "./EnvironmentBanner";

type PageContainerProps = {
  as?: React.ElementType;
  className?: string;
  maxWidth?: string;
};

export function PageContainer({
  as,
  className,
  maxWidth,
  children,
}: React.PropsWithChildren<PageContainerProps>) {
  const Container = as || "div";

  if (maxWidth) {
    return (
      <Container className={`${styles.FixedPageContainer} ${className}`}>
        <div style={{ width: "100%", maxWidth: maxWidth }}>{children}</div>
      </Container>
    );
  }

  return <Container className={`${styles.PageContainer} ${className}`}>{children}</Container>;
}

export function TopBarPageContainer({
  title,
  action,
  innerAction,
  backIconOnClick,
  as,
  className,
  maxWidth,
  children,
}: React.PropsWithChildren<TopBarProps & PageContainerProps>) {
  return (
    <div>
      <TopBar.Compact>
        {backIconOnClick ? <TopBar.BackButton onClick={backIconOnClick} /> : null}
        {Array.isArray(title) ? (
          title.map((value) => <TopBar.Breadcrumb key={value}>{value}</TopBar.Breadcrumb>)
        ) : (
          <TopBar.Breadcrumb>{title}</TopBar.Breadcrumb>
        )}
        {innerAction}
        <TopBar.Spacer />
        {action}
      </TopBar.Compact>
      <PageContainer as={as} className={className} maxWidth={maxWidth}>
        {children}
      </PageContainer>
    </div>
  );
}

export function Frame({
  navigation,
  header,
  children,
}: React.PropsWithChildren<{
  navigation: React.ReactNode;
  header: React.ReactNode;
}>) {
  return (
    <div className={styles.Frame}>
      {navigation}
      <div>
        {header}
        <main className={styles.PageContainer}>{children}</main>
      </div>
    </div>
  );
}

export function UniversalLayout() {
  const { pathname } = useLocation();

  return (
    <>
      <EnvironmentBanner />
      <div className={styles.Frame}>
        <NavigationSidebar pathname={pathname} />
        <div>
          <Outlet />
        </div>
      </div>
    </>
  );
}
